module.exports = __webpack_public_path__ + "img/ban_2.044b82b0.png";